import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetCostHistoryReport'
import Component from 'components/Reports/AssetCostHistoryReport'

export default createListViewContainer({ actions, selectors: selectors.assetCostHistoryReport })(Component)
